import { AppConfig } from './types';

export const config: AppConfig = window.__config;

export default config;
